var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoutingLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 432,
    height: 6,
    viewBox: "0 0 432 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5L2.52368e-07 0.113249L-2.52368e-07 5.88675L5 3.5L5 2.5ZM431.887 3.00004L429 0.113286L426.113 3.00004L429 5.88679L431.887 3.00004ZM4.5 3.5L429 3.50004L429 2.50004L4.5 2.5L4.5 3.5Z",
    fill: "url(#paint0_linear_6834_2961)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6834_2961",
    x1: -4.2829e-7,
    y1: 3.75,
    x2: 0.812159,
    y2: 15.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0617363,
    stopColor: "#FFE249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486651,
    stopColor: "#B7FF5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82EFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutingLine);
export default __webpack_public_path__ + "static/media/routing_line.00543025bd5dbfe311ae0617e9868422.svg";
export { ForwardRef as ReactComponent };